
<h6 class="mat-body-1 mat-mdc-card-subtitle margin-none">{{'ss-entities.actor.batch-signing' | translate}}</h6>

<mat-form-field class="small-mat-form-field" >

    <mat-select [value]="valueObs | async" (valueChange)="setActivityBatchSigning($event.value)">
        <mat-option *ngFor="let option of batchSigningDataSource" [value]="option">
            {{option.display | translate}}
        </mat-option>
    </mat-select>

</mat-form-field>
